export enum OpsSocketCommands {
    OccuredAlarmData = 'sendoccuredalarmdata',
    RecoveredAlarmData = 'sendrecoveredalarmdata',
    UnAckOn = 'unAckOn',
    FixedAlarmData = 'fixedalarmData',
}
